import { ICrudLocale } from '@app/i18n/interface';

export const GROUP_MANAGEMENT_LOCALE_EN: ICrudLocale = {
  GROUP: {
    LABEL: {
      SINGULAR: 'Group',
      PLURAL: 'Groups',
    },
    FORM: {
      ADD_TITLE: 'Add group',
      EDIT_TITLE: 'Edit group',
      CARD_TITLE: 'Group details',
      BACK: 'Back to Groups',
      ADD_DESCRIPTION: 'Create a group and choose its roles; its members get those permissions.',
      EDIT_DESCRIPTION: 'Change the group name, roles or status.',
    },
    FIELD: {
      NAME: 'Group',
      ACTIVE: 'Active',
      ROLES: 'Roles',
      USERS: 'Users',
      STATE: 'Status',
    },
    LIST: {
      DESCRIPTION: 'Every user belongs to a group, and the group decides what they can do.',
      ADD: 'Add group',
      TITLE: 'Back office groups',
      CAPTION: 'Groups, their roles and how many users they have',
      EMPTY: 'There are no groups yet.',
      USERS_ONE: '1 user',
      USERS: '{{count}} users',
      ACTIVE: 'Active',
      INACTIVE: 'Disabled',
      EDIT: 'Edit',
      EDIT_ARIA: 'Edit group {{name}}',
      DISABLE: 'Disable',
      DISABLE_ARIA: 'Disable group {{name}}',
      ENABLE: 'Reactivate',
      ENABLE_ARIA: 'Reactivate group {{name}}',
      DELETE: 'Delete',
      DELETE_ARIA: 'Delete group {{name}}',
      VIEW_USERS: 'View users',
      TOGGLE_ERROR: 'We could not change the group status. Please try again.',
    },
    DISABLE: {
      TITLE: 'Disable group {{name}}?',
      BODY: 'Its {{count}} users will lose this group’s permissions until you reactivate it.',
      KEEP: 'Keep it active',
      CONFIRM: 'Disable group',
    },
    DELETE: {
      TITLE: 'Delete group {{name}}?',
      BODY: 'The group is deleted and this cannot be undone from here.',
      USERS: 'It has {{count}} users: they will lose this group’s permissions.',
      KEEP: 'Keep the group',
      CONFIRM: 'Delete group',
      DONE: 'Group {{name}} has been deleted.',
      ERROR: 'We could not delete group {{name}}. Please try again.',
    },
    PROPOSAL: {
      TITLE: 'Permissions by group',
      BADGE: 'Proposal pending confirmation',
      NOTE: 'This table is a proposal to review and does not change anything yet: today each group has the permissions of its roles (Administrator or User). Permissions marked as destructive cancel bookings, refund money, delete data or change prices. Administrator always keeps every permission, so you never lose access.',
      CAPTION: 'Proposed permissions for each group, by area',
      PERMISSION_COL: 'Permission',
      YES: 'Yes',
      NO: 'No',
      DESTRUCTIVE: 'Destructive',
      GROUP: {
        ADMIN: 'Administrator',
        OPERATIONS: 'Operations',
        SUPPORT: 'Customer support',
        READ_ONLY: 'Read only',
      },
      AREA: {
        BOOKINGS: 'Bookings',
        CANCELLATIONS: 'Cancellations',
        CUSTOMERS: 'Customers',
        MARKUPS: 'Markups',
        CATALOG: 'Catalog',
        USERS: 'Users',
        PROVIDER_CALLS: 'Hotelbeds calls',
      },
      PERMISSION: {
        VIEW_BOOKINGS: 'View bookings',
        VIEW_BOOKINGS_D: 'List and detail of each booking',
        RESEND_VOUCHER: 'Resend the voucher',
        RESEND_VOUCHER_D: 'Sends the voucher to the customer again',
        CHECK_STATUS: 'Check the status at Hotelbeds',
        CHECK_STATUS_D: 'Checks a booking status at Hotelbeds',
        CANCEL_BOOKINGS: 'Cancel bookings',
        CANCEL_BOOKINGS_D: 'Cancels at Hotelbeds and applies the cancellation policy',
        REFUND: 'Refund the customer',
        REFUND_D: 'Returns money through Stripe',
        VIEW_CUSTOMERS: 'View customers',
        VIEW_CUSTOMERS_D: 'Customer list and their details',
        EXPORT_CUSTOMERS: 'Export customers to CSV',
        EXPORT_CUSTOMERS_D: 'Downloads personal data',
        DELETE_CUSTOMERS: 'Delete customers',
        DELETE_CUSTOMERS_D: 'Deletes a customer account',
        VIEW_MARKUPS: 'View markups',
        VIEW_MARKUPS_D: 'Markups, RSP and exchange rate',
        EDIT_MARKUPS: 'Edit markups',
        EDIT_MARKUPS_D: 'Changes the selling price of rates',
        VIEW_CATALOG: 'View the catalog',
        VIEW_CATALOG_D: 'Hotels, destinations and sync status',
        RUN_SYNC: 'Run the sync now',
        RUN_SYNC_D: 'Starts a content sync',
        VIEW_USERS: 'View users and groups',
        VIEW_USERS_D: 'Team list and permissions',
        EDIT_USERS: 'Add and edit users',
        EDIT_USERS_D: 'Adds someone or changes their group',
        DISABLE_USERS: 'Disable users',
        DISABLE_USERS_D: 'Closes a person’s access',
        DELETE_USERS: 'Delete users',
        DELETE_USERS_D: 'Deletes a person’s account',
        VIEW_CALLS: 'View the call log',
        VIEW_CALLS_D: 'Time, operation and status of each call',
        VIEW_RAW_CALLS: 'View full requests and responses',
        VIEW_RAW_CALLS_D: 'Full content sent and received',
      },
    },
  },
};
